export default class NormalSpinState {
	constructor(scene, stateMachine) {
		this.stateMachine = stateMachine;
		this.stateObject = scene;
		this.slotControls = scene.slotControls;
		this.spinButton = this.slotControls.slotSpinButton;
		this.autoSpinButton = this.slotControls.slotAutoSpinButton;
		this.guiController;
		this.subState = null;
	}

	enterFrom(oldState) {
		console.log(this.toString() + ' - Enter From: ' + oldState.toString());
		if (this.spinButton !== null) {
			this.spinButton.longPressClickEvent.add(this.longPressSpin_Click);
			this.spinButton.clickEvent.add(this.spin_Click);
			this.spinButton.pointerDownEvent.add(this.spin_PointerDown);
			this.spinButton.longPointerDownEvent.add(this.spin_LongPointerDown);
		}

		if (this.autoSpinButton !== null) {
			this.autoSpinButton.clickEvent.add(this.autoSpin_Click);
		}

		this.slotControls.setSpinButtonText('SPIN');
		this.slotControls.setControlActivity(false, false, false); // activity, spinButtonAcivity, autoSpinButtonAcivity
		console.log(this.toString() + '  - run normal spin');
		this.slotControls.applyBet();
		this.stateObject.runSlot();
	}

	exitTo(newState) {
		if (this.spinButton !== null) {
			this.spinButton.longPressClickEvent.remove(this.longPressSpin_Click);
			this.spinButton.clickEvent.remove(this.spin_Click);
			this.spinButton.pointerDownEvent.remove(this.spin_PointerDown);
			this.spinButton.longPointerDownEvent.remove(this.spin_LongPointerDown);
		}
		if (this.autoSpinButton !== null) {
			this.autoSpinButton.clickEvent.remove(this.autoSpin_Click);
		}
	}

	// region input
	spin_PointerDown() {}

	spin_LongPointerDown() {}

	longPressSpin_Click() {}

	spin_Click() {}

	autoSpin_Click() {}
	//endregion input

	//region old
	handleInput() {}

	physicsUpdate() {}
	//endregion old

	toString() {
		return 'NormalSpinState';
	}

	calcWinHandler(win) {
		if (win) this.stateMachine.changeState(this.stateObject.winState);
		else this.stateMachine.changeState(this.stateObject.looseState);
	}
}
